import { useEffect } from 'react';

import useEnv from '~/hooks/useEnv';

const Meta = () => {
  const env = useEnv();

  useEffect(() => {
    const script = document.createElement('script');

    script.type = 'text/javascript';
    script.src =
      'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_GB/appleid.auth.js';

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [env]);

  return (
    <>
      <meta name="appleid-signin-client-id" content={env.APPLE_CLIENT_ID} />
      <meta name="appleid-signin-scope" content="name email" />
      <meta name="appleid-signin-redirect-uri" content={env.SITE_BASE_URL} />
      <meta name="appleid-signin-use-popup" content="true" />
    </>
  );
};

export default Meta;
